<template>
  <el-menu
    ref="menuRef"
    :collapse="isCollapse"
    :collapse-transition="true"
    :unique-opened="uniqueOpened"
    :default-openeds="openedMenus"
    :default-active="activeMenu"
    mode="vertical"
    :router="true"
  >
    <template v-for="item in menuList" :key="item.path">
      <SidebarMenuItem
        :item="item"
        :is-collapse="isCollapse"
        :level="1"
        :base-path="item.path"
        :active-menu="activeMenu"
        @menu-click="handleMenuItemClick"
      />
    </template>
  </el-menu>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SidebarMenuItem from './SidebarMenuItem.vue'
import { sidebarConfig } from '@/config/sidebar.config'
import { useMenuStore } from '@/stores'

const route = useRoute()
const router = useRouter()
const menuStore = useMenuStore()
const menuRef = ref()

const menuList = computed(() => menuStore.sidebarMenus)
const isCollapse = computed(() => menuStore.isCollapsed)

const props = defineProps<{
  openedMenus?: string[]
}>()

const openedMenus = computed(() => {
  return props.openedMenus || []
})

const activeMenu = computed(() => route.path)

const collapseTransition = computed(() => true)
const uniqueOpened = computed(() => sidebarConfig.uniqueOpened ?? true)

const handleMenuItemClick = (path: string) => {
  menuStore.setActiveMenu(path.replace('/layout/', ''))
  router.push(path)
}
</script>
